var _regeneratorRuntime = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _objectWithoutProperties = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _excluded = ["url", "path", "data", "parse"],
    _excluded2 = ["path", "url"];
!function webpackUniversalModuleDefinition(e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports["@wordpress/api-fetch"] = r() : (e.wp = e.wp || {}, e.wp.apiFetch = r());
}(self, function () {
  return e = {
    424: function _(e) {
      e.exports = function _interopRequireDefault(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
    },
    817: function _(e, r, t) {
      "use strict";

      var o = t(424);
      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;
      var a = t(756),
          n = o(t(86)),
          s = o(t(220)),
          i = o(t(707)),
          d = o(t(987)),
          u = o(t(831)),
          c = o(t(37)),
          l = o(t(928)),
          p = o(t(562)),
          f = t(915);

      var h = {
        Accept: "application/json, */*;q=0.1"
      },
          _ = {
        credentials: "include"
      },
          v = [l.default, u.default, c.default, d.default],
          checkStatus = function checkStatus(e) {
        if (e.status >= 200 && e.status < 300) return e;
        throw e;
      };

      var fetchHandler = function fetchHandler(e) {
        var r = e.url,
            t = e.path,
            o = e.data,
            _e$parse = e.parse,
            n = _e$parse === void 0 ? !0 : _e$parse,
            s = _objectWithoutProperties(e, _excluded);

        var i = e.body,
            d = e.headers;
        return d = _objectSpread(_objectSpread({}, h), d), o && (i = JSON.stringify(o), d["Content-Type"] = "application/json"), window.fetch(r || t || window.location.href, _objectSpread(_objectSpread(_objectSpread({}, _), s), {}, {
          body: i,
          headers: d
        })).then(function (e) {
          return Promise.resolve(e).then(checkStatus).catch(function (e) {
            return (0, f.parseAndThrowError)(e, n);
          }).then(function (e) {
            return (0, f.parseResponseAndNormalizeError)(e, n);
          });
        }, function (e) {
          if (e && "AbortError" === e.name) throw e;
          throw {
            code: "fetch_error",
            message: (0, a.__)("You are probably offline.")
          };
        });
      };

      function apiFetch(e) {
        return v.reduceRight(function (e, r) {
          return function (t) {
            return r(t, e);
          };
        }, fetchHandler)(e).catch(function (r) {
          return "rest_cookie_invalid_nonce" !== r.code ? Promise.reject(r) : window.fetch(apiFetch.nonceEndpoint).then(checkStatus).then(function (e) {
            return e.text();
          }).then(function (r) {
            return apiFetch.nonceMiddleware.nonce = r, apiFetch(e);
          });
        });
      }

      apiFetch.use = function registerMiddleware(e) {
        v.unshift(e);
      }, apiFetch.setFetchHandler = function setFetchHandler(e) {
        fetchHandler = e;
      }, apiFetch.createNonceMiddleware = n.default, apiFetch.createPreloadingMiddleware = i.default, apiFetch.createRootURLMiddleware = s.default, apiFetch.fetchAllMiddleware = d.default, apiFetch.mediaUploadMiddleware = p.default;
      var w = apiFetch;
      r.default = w;
    },
    987: function _(e, r, t) {
      "use strict";

      var o = t(424);
      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;
      var a = t(904),
          n = o(t(817));

      var modifyQuery = function modifyQuery(e, r) {
        var t = e.path,
            o = e.url,
            n = _objectWithoutProperties(e, _excluded2);

        return _objectSpread(_objectSpread({}, n), {}, {
          url: o && (0, a.addQueryArgs)(o, r),
          path: t && (0, a.addQueryArgs)(t, r)
        });
      },
          parseResponse = function parseResponse(e) {
        return e.json ? e.json() : Promise.reject(e);
      },
          getNextPageUrl = function getNextPageUrl(e) {
        var _ref = function (e) {
          if (!e) return {};
          var r = e.match(/<([^>]+)>; rel="next"/);
          return r ? {
            next: r[1]
          } : {};
        }(e.headers.get("link")),
            r = _ref.next;

        return r;
      };

      var _default = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, r) {
          var t, o, a, s, _r, _t;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(!1 === e.parse)) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", r(e));

                case 2:
                  if (function (e) {
                    var r = !!e.path && -1 !== e.path.indexOf("per_page=-1"),
                        t = !!e.url && -1 !== e.url.indexOf("per_page=-1");
                    return r || t;
                  }(e)) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", r(e));

                case 4:
                  _context.next = 6;
                  return (0, n.default)(_objectSpread(_objectSpread({}, modifyQuery(e, {
                    per_page: 100
                  })), {}, {
                    parse: !1
                  }));

                case 6:
                  t = _context.sent;
                  _context.next = 9;
                  return parseResponse(t);

                case 9:
                  o = _context.sent;

                  if (Array.isArray(o)) {
                    _context.next = 12;
                    break;
                  }

                  return _context.abrupt("return", o);

                case 12:
                  a = getNextPageUrl(t);

                  if (a) {
                    _context.next = 15;
                    break;
                  }

                  return _context.abrupt("return", o);

                case 15:
                  s = [].concat(o);

                case 16:
                  if (!a) {
                    _context.next = 26;
                    break;
                  }

                  _context.next = 19;
                  return (0, n.default)(_objectSpread(_objectSpread({}, e), {}, {
                    path: void 0,
                    url: a,
                    parse: !1
                  }));

                case 19:
                  _r = _context.sent;
                  _context.next = 22;
                  return parseResponse(_r);

                case 22:
                  _t = _context.sent;
                  s = s.concat(_t), a = getNextPageUrl(_r);

                case 24:
                  _context.next = 16;
                  break;

                case 26:
                  return _context.abrupt("return", s);

                case 27:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function _default(_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }();

      r.default = _default;
    },
    37: function _(e, r) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;
      var t = new Set(["PATCH", "PUT", "DELETE"]),
          o = "GET";

      var _default = function _default(e, r) {
        var _e = e,
            _e$method = _e.method,
            a = _e$method === void 0 ? o : _e$method;
        return t.has(a.toUpperCase()) && (e = _objectSpread(_objectSpread({}, e), {}, {
          headers: _objectSpread(_objectSpread({}, e.headers), {}, {
            "X-HTTP-Method-Override": a,
            "Content-Type": "application/json"
          }),
          method: "POST"
        })), r(e);
      };

      r.default = _default;
    },
    562: function _(e, r, t) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;

      var o = t(756),
          a = t(915),
          _default = function _default(e, r) {
        if (!function isMediaUploadRequest(e) {
          var r = !!e.method && "POST" === e.method;
          return (!!e.path && -1 !== e.path.indexOf("/wp/v2/media") || !!e.url && -1 !== e.url.indexOf("/wp/v2/media")) && r;
        }(e)) return r(e);
        var t = 0;

        var postProcess = function postProcess(e) {
          return t++, r({
            path: "/wp/v2/media/".concat(e, "/post-process"),
            method: "POST",
            data: {
              action: "create-image-subsizes"
            },
            parse: !1
          }).catch(function () {
            return t < 5 ? postProcess(e) : (r({
              path: "/wp/v2/media/".concat(e, "?force=true"),
              method: "DELETE"
            }), Promise.reject());
          });
        };

        return r(_objectSpread(_objectSpread({}, e), {}, {
          parse: !1
        })).catch(function (r) {
          var t = r.headers.get("x-wp-upload-attachment-id");
          return r.status >= 500 && r.status < 600 && t ? postProcess(t).catch(function () {
            return !1 !== e.parse ? Promise.reject({
              code: "post_process",
              message: (0, o.__)("Media upload failed. If this is a photo or a large image, please scale it down and try again.")
            }) : Promise.reject(r);
          }) : (0, a.parseAndThrowError)(r, e.parse);
        }).then(function (r) {
          return (0, a.parseResponseAndNormalizeError)(r, e.parse);
        });
      };

      r.default = _default;
    },
    831: function _(e, r) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;

      var _default = function _default(e, r) {
        var t,
            o,
            a = e.path;
        return "string" == typeof e.namespace && "string" == typeof e.endpoint && (t = e.namespace.replace(/^\/|\/$/g, ""), o = e.endpoint.replace(/^\//, ""), a = o ? t + "/" + o : t), delete e.namespace, delete e.endpoint, r(_objectSpread(_objectSpread({}, e), {}, {
          path: a
        }));
      };

      r.default = _default;
    },
    86: function _(e, r) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;

      var t = function createNonceMiddleware(e) {
        var middleware = function middleware(e, r) {
          var _e$headers = e.headers,
              t = _e$headers === void 0 ? {} : _e$headers;

          for (var o in t) {
            if ("x-wp-nonce" === o.toLowerCase() && t[o] === middleware.nonce) return r(e);
          }

          return r(_objectSpread(_objectSpread({}, e), {}, {
            headers: _objectSpread(_objectSpread({}, t), {}, {
              "X-WP-Nonce": middleware.nonce
            })
          }));
        };

        return middleware.nonce = e, middleware;
      };

      r.default = t;
    },
    707: function _(e, r, t) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;

      var o = t(904),
          a = function createPreloadingMiddleware(e) {
        var r = Object.keys(e).reduce(function (r, t) {
          return r[(0, o.normalizePath)(t)] = e[t], r;
        }, {});
        return function (e, t) {
          var _e$parse2 = e.parse,
              a = _e$parse2 === void 0 ? !0 : _e$parse2;
          var n = e.path;

          if (!n && e.url) {
            var _r2 = (0, o.getQueryArg)(e.url, "rest_route");

            "string" == typeof _r2 && (n = _r2);
          }

          if ("string" == typeof n) {
            var _t2 = e.method || "GET",
                s = (0, o.normalizePath)(n);

            if ("GET" === _t2 && r[s]) {
              var _e2 = r[s];
              return delete r[s], Promise.resolve(a ? _e2.body : new window.Response(JSON.stringify(_e2.body), {
                status: 200,
                statusText: "OK",
                headers: _e2.headers
              }));
            }

            if ("OPTIONS" === _t2 && r[_t2] && r[_t2][s]) {
              var _e3 = r[_t2][s];
              return delete r[_t2][s], Promise.resolve(a ? _e3.body : _e3);
            }
          }

          return t(e);
        };
      };

      r.default = a;
    },
    220: function _(e, r, t) {
      "use strict";

      var o = t(424);
      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;

      var a = o(t(831)),
          _default = function _default(e) {
        return function (r, t) {
          return (0, a.default)(r, function (r) {
            var o,
                a = r.url,
                n = r.path;
            return "string" == typeof n && (o = e, -1 !== e.indexOf("?") && (n = n.replace("?", "&")), n = n.replace(/^\//, ""), "string" == typeof o && -1 !== o.indexOf("?") && (n = n.replace("?", "&")), a = o + n), t(_objectSpread(_objectSpread({}, r), {}, {
              url: a
            }));
          });
        };
      };

      r.default = _default;
    },
    928: function _(e, r, t) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.default = void 0;

      var o = t(904),
          _default = function _default(e, r) {
        return "string" != typeof e.url || (0, o.hasQueryArg)(e.url, "_locale") || (e.url = (0, o.addQueryArgs)(e.url, {
          _locale: "user"
        })), "string" != typeof e.path || (0, o.hasQueryArg)(e.path, "_locale") || (e.path = (0, o.addQueryArgs)(e.path, {
          _locale: "user"
        })), r(e);
      };

      r.default = _default;
    },
    915: function _(e, r, t) {
      "use strict";

      Object.defineProperty(r, "__esModule", {
        value: !0
      }), r.parseAndThrowError = parseAndThrowError, r.parseResponseAndNormalizeError = void 0;
      var o = t(756);

      var parseResponse = function parseResponse(e) {
        var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        return r ? 204 === e.status ? null : e.json ? e.json() : Promise.reject(e) : e;
      },
          parseJsonAndNormalizeError = function parseJsonAndNormalizeError(e) {
        var r = {
          code: "invalid_json",
          message: (0, o.__)("The response is not a valid JSON response.")
        };
        if (!e || !e.json) throw r;
        return e.json().catch(function () {
          throw r;
        });
      };

      function parseAndThrowError(e) {
        var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        if (!r) throw e;
        return parseJsonAndNormalizeError(e).then(function (e) {
          var r = {
            code: "unknown_error",
            message: (0, o.__)("An unknown error occurred.")
          };
          throw e || r;
        });
      }

      r.parseResponseAndNormalizeError = function (e) {
        var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        return Promise.resolve(parseResponse(e, r)).catch(function (e) {
          return parseAndThrowError(e, r);
        });
      };
    },
    756: function _(e) {
      "use strict";

      e.exports = require("@wordpress/i18n");
    },
    904: function _(e) {
      "use strict";

      e.exports = require("@wordpress/url");
    }
  }, r = {}, t = function __webpack_require__(t) {
    var o = r[t];
    if (void 0 !== o) return o.exports;
    var a = r[t] = {
      exports: {}
    };
    return e[t](a, a.exports, __webpack_require__), a.exports;
  }(817), t;
  var e, r, t;
});